
export interface MailDiagResultDto {
  correlationId?: string;
  acceptedBySmtp: boolean;
  error?: string;
  senderType?: string;
  from?: string;
  to?: string;
  host?: string;
  port?: string;
  enableSsl?: string;
  user?: string;
}
